export default __webpack_public_path__ + "static/media/comprobado.6f298cca.png";